const Bag = ({ ...props }) => {
    return (
        <svg
            width="21"
            height="19"
            viewBox="0 0 21 19"
            stroke="currentColor"
            {...props}
        >
            <g
                id="Symbols"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="d/header.utility"
                    transform="translate(-191.000000, 0.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                    stroke="currentColor"
                    strokeWidth="0.25"
                >
                    <g id="Group-2" transform="translate(192.479675, 1.000000)">
                        <path
                            d="M17.5477778,3.47555556 C17.2077778,3.04111111 16.6788889,2.77666667 16.1311111,2.77666667 L4.62777778,2.77666667 L4.26888889,1.37888889 C4.06111111,0.566666667 3.34333333,3.55271368e-15 2.51222222,3.55271368e-15 L0.585555556,3.55271368e-15 C0.264444444,3.55271368e-15 1.95399252e-14,0.264444444 1.95399252e-14,0.585555556 C1.95399252e-14,0.906666667 0.264444444,1.17111111 0.585555556,1.17111111 L2.51222222,1.17111111 C2.79555556,1.17111111 3.04111111,1.36 3.11666667,1.64333333 L5.42111111,10.8233333 C5.62888889,11.6355556 6.34666667,12.2022222 7.17777778,12.2022222 L14.7144444,12.2022222 C15.5455556,12.2022222 16.2822222,11.6355556 16.4711111,10.8233333 L17.8877778,5.00555556 C18.02,4.47666667 17.9066667,3.91 17.5477778,3.47555556 Z M16.7355556,4.74111111 L15.3188889,10.5588889 C15.2433333,10.8422222 14.9977778,11.0311111 14.7144444,11.0311111 L7.17777778,11.0311111 C6.89444444,11.0311111 6.64888889,10.8422222 6.57333333,10.5588889 L4.93,3.96666667 L16.1311111,3.96666667 C16.32,3.96666667 16.5088889,4.06111111 16.6222222,4.21222222 C16.7355556,4.36333333 16.7922222,4.55222222 16.7355556,4.74111111 Z"
                            id="Shape"
                        />
                        <path
                            d="M7.57444444,12.9577778 C6.49777778,12.9577778 5.61,13.8455556 5.61,14.9222222 C5.61,15.9988889 6.49777778,16.8866667 7.57444444,16.8866667 C8.65111111,16.8866667 9.53888889,15.9988889 9.53888889,14.9222222 C9.53888889,13.8455556 8.65111111,12.9577778 7.57444444,12.9577778 Z M7.57444444,15.6966667 C7.14,15.6966667 6.8,15.3566667 6.8,14.9222222 C6.8,14.4877778 7.14,14.1477778 7.57444444,14.1477778 C8.00888889,14.1477778 8.34888889,14.4877778 8.34888889,14.9222222 C8.34888889,15.3377778 7.99,15.6966667 7.57444444,15.6966667 Z"
                            id="Shape"
                        />
                        <path
                            d="M14.0722222,12.9577778 C12.9955556,12.9577778 12.1077778,13.8455556 12.1077778,14.9222222 C12.1077778,15.9988889 12.9955556,16.8866667 14.0722222,16.8866667 C15.1488889,16.8866667 16.0366667,15.9988889 16.0366667,14.9222222 C16.0177778,13.8455556 15.1488889,12.9577778 14.0722222,12.9577778 Z M14.0722222,15.6966667 C13.6377778,15.6966667 13.2977778,15.3566667 13.2977778,14.9222222 C13.2977778,14.4877778 13.6377778,14.1477778 14.0722222,14.1477778 C14.5066667,14.1477778 14.8466667,14.4877778 14.8466667,14.9222222 C14.8466667,15.3377778 14.4877778,15.6966667 14.0722222,15.6966667 Z"
                            id="Shape"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Bag
